// utils
import _, { split } from 'lodash';
// config
import { TYPE } from 'app/config/prescription_content_suggestion_scheduling';
import { FREQUENCY_SCHEDULE } from 'app/config/frequency_type';

export function applySuggestScheduling(values) {
  const { padPrescriptionSuggestionScheduling } = values;

  if (_.isEmpty(padPrescriptionSuggestionScheduling)) {
    return {
      ...values
    };
  }

  const padPrescriptionSuggestionSchedulingType = padPrescriptionSuggestionScheduling[0].type;

  if (padPrescriptionSuggestionSchedulingType === TYPE.FIRST_APPLICATION) {
    const scheduleType = FREQUENCY_SCHEDULE.SPECIFIC_TIME;
    const dateAndTime = padPrescriptionSuggestionScheduling[0];
    const firstApplicationDate = new Date(dateAndTime.applicationDate);
    const [hour, minute] = split(dateAndTime.applicationTime, ':');
    const firstApplicationTime = `${hour}:${minute}`;

    return {
      ...values,
      firstApplicationDate,
      firstApplicationTime,
      scheduleType
    };
  }

  if (padPrescriptionSuggestionSchedulingType === TYPE.DAY_HOUR) {
    const scheduleType = FREQUENCY_SCHEDULE.SPECIFIC_TIME;
    let applicationTimes = [];

    // eslint-disable-next-line no-unused-vars
    for (const padPrescrSuggSched of padPrescriptionSuggestionScheduling) {
      const { applicationTime } = padPrescrSuggSched;

      applicationTimes.push(applicationTime);
    }

    return {
      ...values,
      applicationTimes,
      scheduleType
    };
  }

  if (padPrescriptionSuggestionSchedulingType === TYPE.DAY_SHIFT) {
    const scheduleType = FREQUENCY_SCHEDULE.PER_SHIFT;
    let perDayPerShifts = [];

    // eslint-disable-next-line no-unused-vars
    for (const padPrescrSuggSched of padPrescriptionSuggestionScheduling) {
      const { shift } = padPrescrSuggSched;

      perDayPerShifts.push(shift);
    }

    return {
      ...values,
      perDayPerShifts,
      scheduleType
    };
  }

  if (padPrescriptionSuggestionSchedulingType === TYPE.WEEK_HOUR) {
    const scheduleType = FREQUENCY_SCHEDULE.SPECIFIC_TIME;
    let daysOfWeek = [];
    let applicationTime = null;
    let perWeekSpecificTime = null;

    // eslint-disable-next-line no-unused-vars
    for (const padPrescrSuggSched of padPrescriptionSuggestionScheduling) {
      const { dayOfWeek } = padPrescrSuggSched;

      daysOfWeek.push(dayOfWeek);
      applicationTime = padPrescrSuggSched.applicationTime;
      perWeekSpecificTime = padPrescrSuggSched.applicationTime;
    }

    return {
      ...values,
      daysOfWeek,
      applicationTime,
      perWeekSpecificTime,
      scheduleType
    };
  }

  if (padPrescriptionSuggestionSchedulingType === TYPE.WEEK_SHIFT) {
    const scheduleType = FREQUENCY_SCHEDULE.PER_SHIFT;
    let daysOfWeek = [];
    let perWeekPerShift = null;

    // eslint-disable-next-line no-unused-vars
    for (const padPrescrSuggSched of padPrescriptionSuggestionScheduling) {
      const { dayOfWeek } = padPrescrSuggSched;

      daysOfWeek.push(dayOfWeek);
      perWeekPerShift = padPrescrSuggSched.shift;
    }

    return {
      ...values,
      daysOfWeek,
      perWeekPerShift,
      scheduleType
    };
  }

  if (padPrescriptionSuggestionSchedulingType === TYPE.MONTH_HOUR) {
    const scheduleType = FREQUENCY_SCHEDULE.SPECIFIC_TIME;
    let perMonthSpecificTime = null;
    let perMonthSpecificTimeDates = [];

    // eslint-disable-next-line no-unused-vars
    for (const padPrescrSuggSched of padPrescriptionSuggestionScheduling) {
      const { applicationDate, applicationTime } = padPrescrSuggSched;

      perMonthSpecificTime = applicationTime;
      perMonthSpecificTimeDates.push(applicationDate);
    }

    return {
      ...values,
      perMonthSpecificTime,
      perMonthSpecificTimeDates,
      scheduleType
    };
  }

  if (padPrescriptionSuggestionSchedulingType === TYPE.MONTH_SHIFT) {
    let perMonthPerShiftDates = [];
    let perMonthPerShift = null;
    const scheduleType = FREQUENCY_SCHEDULE.PER_SHIFT;

    // eslint-disable-next-line no-unused-vars
    for (const padPrescrSuggSched of padPrescriptionSuggestionScheduling) {
      const { applicationDate } = padPrescrSuggSched;

      perMonthPerShiftDates.push(applicationDate);
      perMonthPerShift = padPrescrSuggSched.shift;
    }

    return {
      ...values,
      perMonthPerShiftDates,
      perMonthPerShift,
      scheduleType
    };
  }

  if (!padPrescriptionSuggestionSchedulingType) {
    let perDayPerShifts = values.perDayPerShifts;

    return [...values, perDayPerShifts];
  }
}
